import { useDispatch } from 'react-redux';

import { RequestsEnum } from '../requests/enum';

const progression = {
  started: false,
  success: false,
  error: null
};

export const useDispatchWithProgress = creator => {
  const dispatch = useDispatch();

  return async payload => {
    dispatch({
      type: RequestsEnum.REQUEST_STARTED,
      payload: { name: creator.name, ...progression, started: true }
    });

    try {
      const data = await creator.action(payload);

      dispatch({ type: creator.name, payload: data });
      dispatch({
        type: RequestsEnum.REQUEST_SUCCESS,
        payload: { name: creator.name, ...progression, success: true }
      });
      dispatch({
        type: RequestsEnum.REQUEST_FINISHED,
        payload: { name: creator.name }
      });
    } catch (error) {
      dispatch({
        type: RequestsEnum.REQUEST_FAILED,
        payload: { name: creator.name, ...progression, error }
      });
    }
  };
};

// Doesn't remove request success value for action so can use it to display success snackbar
// Then dispatch REQUEST_FINISHED with action name to remove success value on snackbar close
export const useDispatchWithProgressAndSuccess = creator => {
  const dispatch = useDispatch();

  return async payload => {
    dispatch({
      type: RequestsEnum.REQUEST_STARTED,
      payload: { name: creator.name, ...progression, started: true }
    });

    try {
      const data = await creator.action(payload);

      dispatch({ type: creator.name, payload: data });
      dispatch({
        type: RequestsEnum.REQUEST_SUCCESS,
        payload: { name: creator.name, ...progression, success: true }
      });
    } catch (error) {
      dispatch({
        type: RequestsEnum.REQUEST_FAILED,
        payload: { name: creator.name, ...progression, error }
      });
    }
  };
};
